<template>
  <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap"
                view-class="p20-scrollbar__view">
    <div v-if="loading">
      <el-form style="margin-left: 30px;margin-top: 30px">
        <el-form-item>
          <el-select v-model="status" clearable placeholder="申请状态" @change="queryApply()">
            <el-option label="申请中" :value="1"></el-option>
            <el-option label="已认证" :value="2"></el-option>
            <el-option label="已拒绝" :value="3"></el-option>
          </el-select>
          <el-input v-model="searchForm" placeholder="请输入姓名/手机号" style="width:400px"
                    @keyup.enter.native="queryApply"
                    clearable></el-input>
          <el-button type="primary" @click="queryApply()">搜索</el-button>
          <el-button type="info" style="float: right;margin-right: 50px" @click="guidePage=true">指引</el-button>
        </el-form-item>
      </el-form>

      <el-table
          border
          :header-cell-style="{background:'#dee2ec', color: '#666666'}"
          :cell-style="{'text-align':'center','border-right':'1px solid #eee','border-bottom':'1px solid #eee'}"
          :data="applyList"
          stripe
          max-height="700"
          style="width: 100%;margin-bottom:20px">
        <el-table-column prop="userName" label="用户"></el-table-column>
        <el-table-column prop="wechatPhone" label="手机号"></el-table-column>
        <el-table-column prop="referrer" label="推荐人"></el-table-column>
        <el-table-column prop="intentJobs" label="意向岗位"></el-table-column>
        <el-table-column prop="timeSlots" label="可服务时段"></el-table-column>
        <el-table-column prop="applyNote" label="申请备注"></el-table-column>
        <el-table-column prop="createTime" label="申请时间"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">{{statusText(scope.row.status)}}</template>
        </el-table-column>
        <el-table-column prop="auditNote" label="审核意见"></el-table-column>
        <el-table-column prop="operation" label="操作">
          <template slot-scope="scope" v-if="scope.row.status===1">
            <el-button type="primary" size="medium" @click="approve(scope.row)">通过</el-button>
            <el-button type="danger" size="medium" @click="rejectButton(scope.row)">驳回</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="text-align: center"
                     background
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="pagesizes"
                     :page-size="pagesize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="all">
      </el-pagination>

      <el-dialog title="驳回申请" :visible.sync="rejectPage" width="500px">
        <el-form label-width="100px">
          <el-form-item label="驳回原因" required>
            <el-input v-model="auditNote" type="textarea" placeholder="请填写驳回原因（必填）"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="rejectPage = false">取消</el-button>
          <el-button type="danger" @click="reject()">确认驳回</el-button>
        </div>
      </el-dialog>

      <el-dialog title="指引" :visible.sync="guidePage" width="1000px">
        <div>
          <h2>志愿者管理</h2>
          本页用于审核小程序用户提交的志愿者申请（志愿中心一期）。
          <br>
          <h3> 搜索：可按申请状态、用户姓名/手机号筛选。<br>
            审核：申请中的记录可点“通过”或“驳回”；驳回必须填写驳回原因。<br>
            通过/驳回后用户小程序端「我的」页面入口会相应变化。<br></h3>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="guidePage = false">关 闭</el-button>
        </div>
      </el-dialog>
    </div>
  </el-scrollbar>
</template>
<script>
import {volunteerApplyList, volunteerApplyAudit} from "@/common/js/index.js"

export default {
  name: "volunteerApply",
  // 权限说明：本页面对应权限码 volunteer:audit，当前仅超管可见（后端强制校验）；
  // 店长下放待拍板后配置，届时在此按账号类型控制菜单/按钮可见性
  data() {
    return {
      guidePage: false,
      applyList: [],
      status: '',
      searchForm: '',
      all: 0,
      currentPage: 1,
      loading: false,
      pagesize: 20,
      pagesizes: [10, 20, 30, 50, 100, 200, 300, 400, 500, 1000],
      rejectPage: false,
      rejectId: null,
      auditNote: '',
    }
  },
  methods: {
    statusText(status) {
      if (status === 1) return '申请中'
      if (status === 2) return '已认证'
      if (status === 3) return '已拒绝'
      return '普通'
    },
    queryApply() {
      let subData = 'currPage=' + this.currentPage
          + '&pageSizePara=' + this.pagesize
          + '&userName=' + this.searchForm
      if (this.status !== '' && this.status !== null) {
        subData += '&status=' + this.status
      }
      volunteerApplyList(subData).then(res => {
        if (res) {
          this.applyList = res.data
          if (res.data.length !== 0) {
            this.all = res.data[0].totalCount
          } else {
            this.all = 0
          }
          this.loading = true
        }
      })
    },
    approve(row) {
      this.$confirm('确认通过该用户的志愿者申请？', '提示', {type: 'warning'}).then(() => {
        volunteerApplyAudit('id=' + row.id + '&status=2').then(res => {
          if (res) {
            this.queryApply()
            this.$message({showClose: true, message: '已通过', type: 'success'})
          }
        })
      }).catch(() => {})
    },
    rejectButton(row) {
      this.rejectId = row.id
      this.auditNote = ''
      this.rejectPage = true
    },
    reject() {
      if (!this.auditNote || !this.auditNote.trim()) {
        this.$message.error('驳回时必须填写驳回原因')
        return
      }
      volunteerApplyAudit('id=' + this.rejectId + '&status=3&auditNote=' + encodeURIComponent(this.auditNote)).then(res => {
        if (res) {
          this.rejectPage = false
          this.queryApply()
          this.$message({showClose: true, message: '已驳回', type: 'success'})
        }
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleSizeChange(val) {
      this.pagesize = val
    },
  },
  created() {
    this.queryApply();
  },
  watch: {
    currentPage: function () {
      this.queryApply()
    },
    pagesize: function () {
      this.queryApply()
    },
  }
}
</script>

<style scoped>
</style>
